import { Dispatch } from "react";
import { IActionType, IAssignTourPayload, IReassignTourPayload } from "../../interfaces/Index";
import * as actionTypes from "../actionTypes/Index";
import { assignPlanApiCall, assignTourApiCall, reassignTourApiCall } from "../sources/ShipperSource";
import { multiPartUploadApiCall } from "../sources/GlobalProductSource";

export const assignTourInit = () => ({
  type: actionTypes.ASSIGN_TOUR_INIT,
});

export const assignTourSuccess = () => ({
  type: actionTypes.ASSIGN_TOUR_SUCCESS,
});

export const assignTourFail = (error: string | object | null) => ({
  type: actionTypes.ASSIGN_TOUR_FAIL,
  error,
});

export const assignPlanInit = () => ({
  type: actionTypes.ASSIGN_PLAN_INIT,
});

export const assignPlanSuccess = () => ({
  type: actionTypes.ASSIGN_PLAN_SUCCESS,
});

export const assignPlanFail = (error: string | object | null) => ({
  type: actionTypes.ASSIGN_PLAN_FAIL,
  error,
});

export const tourUploadCsvInit = () => ({
  type: actionTypes.UPLOAD_TOUR_CSV_INIT,
});

export const tourUploadCsvSuccess = () => ({
  type: actionTypes.UPLOAD_TOUR_CSV_SUCCESS,
});

export const tourUploadCsvFail = (error: string | object | null) => ({
  type: actionTypes.UPLOAD_TOUR_CSV_FAIL,
  error,
});

export const upload3plTourCsvInit = () => ({
  type: actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_INIT,
});

export const upload3plTourCsvSuccess = () => ({
  type: actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_SUCCESS,
});

export const upload3plTourCsvFail = (error: string | object | null) => ({
  type: actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_FAIL,
  error,
});

// async actions
export const assignTour = (payload: IAssignTourPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(assignTourInit());
  return assignTourApiCall(payload)
    .then(() => dispatch(assignTourSuccess()))
    .catch((e: object | null | string) => dispatch(assignTourFail(e)));
};


export const reassignTour = (payload: IReassignTourPayload) => (
  dispatch: Dispatch<IActionType>
) => {
  // using same internal actions as assignTour.
  dispatch(assignTourInit());
  return reassignTourApiCall(payload)
    .then(() => dispatch(assignTourSuccess()))
    .catch((e: object | null | string) => dispatch(assignTourFail(e)));
};


export const assignPlan = (payload: string[]) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(assignPlanInit());
  return assignPlanApiCall(payload)
    .then(() => dispatch(assignPlanSuccess()))
    .catch((e: object | null | string) => dispatch(assignPlanFail(e)));
};

export const uploadTourCsv = (payload: FormData, url: string) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(tourUploadCsvInit());
  return multiPartUploadApiCall(payload, url)
    .then(() => dispatch(tourUploadCsvSuccess()))
    .catch((e: object | null | string) => dispatch(tourUploadCsvFail(e)));
};

export const upload3plTourCsv = (payload: FormData, url: string) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(upload3plTourCsvInit());
  return multiPartUploadApiCall(payload, url)
    .then(() => dispatch(upload3plTourCsvSuccess()))
    .catch((e: object | null | string) => dispatch(upload3plTourCsvFail(e)));
};
